import { DeviationTypes } from '../types/deviation';
import { MediaSourceType } from './types';
export const reduxKey = '@@MediaPopup';
export const MEDIA_POPUP_POLL_STREAM_ID = 'MEDIA_POPUP_POLL_STREAM_ID';
export const MEDIA_POPUP_STATUS_STREAM_ID = 'MEDIA_POPUP_STATUS_STREAM_ID';
export const MEDIA_POPUP_JOURNAL_STREAM_ID = 'MEDIA_POPUP_JOURNAL_STREAM_ID';
export const MEDIA_POPUP_POSTS_STREAM_ID = 'MEDIA_POPUP_POSTS_STREAM_ID';
export const MEDIA_POPUP_BROWSE_DEVIATION_STREAM_ID = 'MEDIA_POPUP_BROWSE_DEVIATION_STREAM_ID';
export const MEDIA_POPUP_BROWSE_SEARCH_DEVIATION_STREAM_ID = 'MEDIA_POPUP_BROWSE_SEARCH_DEVIATION_STREAM_ID';
export const MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP = 'MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP';
export const MEDIA_POPUP_GALLECTION_DEVIATION_SEARCH_STREAM_GROUP = 'MEDIA_POPUP_GALLECTION_DEVIATION_SEARCH_STREAM_GROUP';
export const MEDIA_POPUP_GALLECTION_STREAM_GROUP = 'MEDIA_POPUP_GALLECTION_STREAM_GROUP';
export const MEDIA_POPUP_CUSTOM_DEVIATION_SET_STREAM_ID = 'MEDIA_POPUP_CUSTOM_DEVIATION_SET_STREAM_ID';
export const MEDIA_POPUP_COMMISSION_STREAM_ID = 'MEDIA_POPUP_COMMISSION_STREAM_ID';
export const MEDIA_POPUP_TIER_STREAM_ID = 'MEDIA_POPUP_TIER_STREAM_ID';
export const MEDIA_POPUP_TIER_DEVIATION_STREAM_GROUP = 'MEDIA_POPUP_TIER_DEVIATION_STREAM_GROUP';
export const DEVIATIONS_PER_FETCH = 24;
export const GALLECTIONS_PER_FETCH = 250;
export const MAX_SELECTED_ITEMS = 24;
export const TIERS_PER_FETCH = 24;
export const DEVIATION_THUMB_HEIGHT = 120;
export const DEFAULT_MEDIASOURCE_TYPES_FOR_MEDIA_MANAGER = [
    MediaSourceType.GALLERY,
    MediaSourceType.COLLECTION,
    MediaSourceType.STASH,
    MediaSourceType.BROWSE
];
export const DEFAULT_MEDIASOURCE_TYPES_FOR_MEDIA_SELECTOR = [
    MediaSourceType.GALLERY,
    MediaSourceType.COLLECTION,
    MediaSourceType.PRIVATE_COLLECTION,
    MediaSourceType.POSTS,
    MediaSourceType.STASH,
    MediaSourceType.TIER,
    MediaSourceType.TIER_DEVIATIONS,
    MediaSourceType.TIER_POSTS,
    MediaSourceType.COMMISSIONS,
    MediaSourceType.BROWSE
];
export const DEVIATION_TYPES_ALLOWED_AS_FOLDER_COVER = [
    DeviationTypes.IMAGE,
    DeviationTypes.LITERATURE
];

//# sourceMappingURL=constants.js.map